export default __webpack_public_path__ + "d9eaf9e4023b94b642f726d4626fdbc3.png";